import CryptoJS from 'crypto-js';

const SECRET_KEY =
  '1516a14e63bcfcf9@354367051ec6d7@c25eb9f1b7cfc0521734f8@efb6f302951a' as string;
async function generateSignature(params: any) {
  const sortedKeys = Object.keys(params).sort();

  const queryString = sortedKeys
    .map((key) => {
      if (
        params[key] !== undefined &&
        params[key] !== null &&
        params[key] !== ''
      ) {
        return `${key}=${params[key]}`;
      }
    })
    .filter((key) => key)
    .join('&');

  // 使用 HmacSHA256 进行哈希计算
  if (!queryString) {
    return '';
  }

  const hash = CryptoJS.HmacSHA256(
    queryString,
    SECRET_KEY?.replace(/@/g, '')
  ).toString(CryptoJS.enc.Hex);

  return hash;
}

export default generateSignature;
